import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import UploadPage from './pages/UploadPage';
import TableSelectionPage from './pages/TableSelectionPage';
import GeneratePage from './pages/GeneratePage';
import ProductOverviewPage from './pages/ProductOverviewPage';
import CreateTaskPipelinePage from './pages/CreateTaskPipelinePage';
import DataWorkspacePage from './pages/DataWorkspacePage';
import RunFlowchartPage from './pages/RunFlowchartPage';
import ExportDestinationPage from './pages/ExportDestinationPage';
import { AppProvider } from './context/AppContext';
import { NotificationProvider } from './context/NotificationContext';
import { ThemeProvider } from './context/ThemeContext';

function App() {
  return (
    <ThemeProvider>
      <AppProvider>
        <NotificationProvider>
        <Router>
          <div className="App">
            <Routes>
              <Route path="/" element={<Layout />}>
                <Route index element={<UploadPage />} />
                <Route path="overview" element={<ProductOverviewPage />} />
                <Route path="create-pipeline" element={<CreateTaskPipelinePage />} />
                <Route path="workspace" element={<DataWorkspacePage />} />
                {/* Redirect /runs to main page since UploadPage now has runs sidebar */}
                <Route path="runs" element={<Navigate to="/" replace />} />
                {/* Specific routes first, then general route */}
                <Route path="run/:runId/select" element={<TableSelectionPage />} />
                <Route path="run/:runId/generate" element={<GeneratePage />} />
                <Route path="run/:runId/export" element={<ExportDestinationPage />} />
                <Route path="run/:runId" element={<RunFlowchartPage />} />
                {/* Redirect old routes to new combined page */}
                <Route path="run/:runId/business-rules" element={<Navigate to="../generate" replace />} />
                <Route path="run/:runId/results" element={<Navigate to="../generate" replace />} />
              </Route>
            </Routes>
          </div>
        </Router>
      </NotificationProvider>
      </AppProvider>
    </ThemeProvider>
  );
}

export default App;

